import React from 'react'
import { Redirect, useParams } from 'react-router-dom'

import { Routes } from '../../navigation/config/routes'

export const VoiceAgentCallDetail: React.FC = () => {
    const { id } = useParams<{ id: string }>()
    return (
        <Redirect
            to={`${Routes.manage.voiceAgent.root}?tab=calls&call=${id}`}
        />
    )
}
